import Layout, { LayoutElement, LayoutType } from 'domain/entity/layout';
import UpdateLayoutCriteria from 'use-case/layout/update/updateLayoutCriteria';
import { getApiClient } from 'adapter/out/client/apiClient';
import { LayoutJson, asLayoutElements } from 'adapter/out/client/layout/readLayoutsApiClient';

const asLayoutToUpdate = (layout: Layout): jsonUpdateTemplate => ({
    type: layout.type,
    widgets: layout.widgets.map((widgetLayout: LayoutElement) => ({
        id: widgetLayout.id,
        type: widgetLayout.type,
        position: { x: widgetLayout.position.x, y: widgetLayout.position.y },
        size: { width: widgetLayout.size.width, height: widgetLayout.size.height },
    })),
});

const asLayout = (layoutsJson: LayoutJson) => ({ type: layoutsJson.type as LayoutType, widgets: asLayoutElements(layoutsJson.widgets) });

const updateLayoutApiClient = getApiClient(
    (criteria: UpdateLayoutCriteria) => `dashboards/dashboards/${criteria.dashboardId}/layouts/${criteria.layout.type}`,
    Layout,
    (criteria: UpdateLayoutCriteria) => ({
        method: 'PUT',
        body: JSON.stringify(asLayoutToUpdate(criteria.layout)),
        headers: { 'Content-Type': 'application/json' },
    }),
    asLayout
);

type jsonUpdateTemplate = {
    type: string;
    widgets: { id: string; position: { x: number; y: number }; size: { width: number; height: number } }[];
};

export default updateLayoutApiClient;
